import { ExpressionOfWishClient } from "../../../../../../../../Wrap/Api/Account/ExpressionOfWish";

export class ExpressionOfWishDocumentAction {
    public static get(hierarchyId: string, callback) {
        const client = new ExpressionOfWishClient();
        const promise = client.get([hierarchyId]);

        promise.onSuccess((data) => {
            callback(data);
        });

        promise.onError(() => {});
    }
}